import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { ICustomField, CustomField } from "@/models/custom-field.entity";

export const CustomFieldDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<ICustomField, ""> {
  getIdentifier(entity: ICustomField): string {
    return (entity as ICustomField).id;
  }

  mapEntity(entity: ICustomField): ICustomField {
    return new CustomField(entity);
  }
})();
